import { lazyConversationConversationNodesWebResolver } from 'conversation-conversation-nodes-web';
import { lazyMarkAllAsReadWeb } from 'folder-mark-all-as-read-mutation-web';
import { lazyCategorizeItemWeb } from 'item-categorize-mutation-web';
import { lazyMarkItemAsReadWeb } from 'item-mark-as-read-mutation-web';
import { lazyCreateDraftWeb } from 'outlook-mail-compose-web';
import { Resolvers } from 'owa-graph-schema';
import { lazyQueryConversationNodeWeb } from 'query-conversation-node-web';
import { lazyQueryConversationWeb } from 'query-conversation-web';
import { lazyQueryItemWeb } from 'query-item-web';
import { lazyQueryItemsWeb } from 'query-items-web';
import { lazyUserConfigurationWeb } from 'userconfiguration-query-web';
import {
    lazyDeleteConversationWeb,
    lazyUndoDeleteConversationWeb,
} from 'conversation-delete-mutation-web';
import {
    lazyFolderWeb,
    lazyFolderHierarchyWeb,
    lazyFoldersWeb,
    lazyRenameFolderWeb,
    lazyEmptyFolderWeb,
    lazyDeleteFolderWeb,
    lazyMoveFolderWeb,
    lazyCreateFolderWeb,
    lazySubscribeToHierarchyNotificationsWeb,
    lazyUpdateFolderPermissionsWeb,
} from 'outlook-folders-web';
import {
    lazySubscribeToRowNotificationsWeb,
    lazyConversationRowByIdWeb,
    lazyConversationRowsWeb,
} from 'outlook-listview-web';
import {
    lazyMarkConversationAsReadWeb,
    lazyCategorizeConversationWeb,
} from 'outlook-conversation-rows-web';
import { lazyScheduleConversationWeb } from 'conversation-schedule-mutation-web';

/**
 * Please keep fields alphebatized to minimize merge conflicts
 */
export const webResolvers: Resolvers = {
    /* ======================== */
    /* Resolvers for root types */
    /* ======================== */

    /**
     * The root query type. All queries that fetch data start at the Query type.
     * Resolvers under Query should not have effects
     *
     * See https://graphql.org/learn/schema/#the-query-and-mutation-types
     */
    Query: {
        conversation: lazyQueryConversationWeb,
        conversationNode: lazyQueryConversationNodeWeb,
        conversationRowById: lazyConversationRowByIdWeb,
        conversationRows: lazyConversationRowsWeb,
        folder: lazyFolderWeb,
        folderHierarchy: lazyFolderHierarchyWeb,
        folders: lazyFoldersWeb,
        item: lazyQueryItemWeb,
        items: lazyQueryItemsWeb,
        userConfiguration: lazyUserConfigurationWeb,
    },

    /**
     * The root mutation type. All queries that alter data start at the Mutation type.
     * Mutations typically return the mutated data.
     *
     * See https://graphql.org/learn/schema/#the-query-and-mutation-types
     */
    Mutation: {
        categorizeConversation: lazyCategorizeConversationWeb,
        categorizeItem: lazyCategorizeItemWeb,
        createDraft: lazyCreateDraftWeb,
        createFolder: lazyCreateFolderWeb,
        deleteFolder: lazyDeleteFolderWeb,
        deleteConversation: lazyDeleteConversationWeb,
        emptyFolder: lazyEmptyFolderWeb,
        markConversationAsRead: lazyMarkConversationAsReadWeb,
        markAllAsRead: lazyMarkAllAsReadWeb,
        markItemAsRead: lazyMarkItemAsReadWeb,
        moveFolder: lazyMoveFolderWeb,
        renameFolder: lazyRenameFolderWeb,
        scheduleConversation: lazyScheduleConversationWeb,
        updateFolderPermissions: lazyUpdateFolderPermissionsWeb,
        undoDeleteConversation: lazyUndoDeleteConversationWeb,
    },

    /**
     * The root subscription type. Resolvers under subscriptions return an event stream
     * that the client responds to.
     *
     * For for definition and rationale, see https://graphql.org/blog/subscriptions-in-graphql-and-relay/#event-based-subscriptions
     * For resolver implementation, see https://www.apollographql.com/docs/apollo-server/data/subscriptions
     * For client consumption, see https://www.apollographql.com/docs/react/data/subscriptions
     */
    Subscription: {
        subscribeToHierarchyNotifications: lazySubscribeToHierarchyNotificationsWeb,
        subscribeToRowNotifications: lazySubscribeToRowNotificationsWeb,
    },

    /* ============================ */
    /* Resolvers for non-root types */
    /* ============================ */

    Conversation: {
        conversationNodes: lazyConversationConversationNodesWebResolver,
    },
};
